import React  from 'react';

import Layout from '../components/layouts/standard-page.js';
import ContentLayout from '../components/layouts/content-standard-page.js';
import Card from '../components/card.js';
import CardBody from '../components/card-body.js';
import CardHeader from '../components/card-header.js';
import LanguageSelector from '../components/inputs/language-selector.js';
import {Checkbox , Pagination , Table , Row , Col , Alert , FormGroup , ControlLabel , FormControl , Button} from 'react-bootstrap';
import ContentService from '../services/content-service.js';
import ContentStore   from  '../store/content-store.js';
import {BootstrapTable, TableHeaderColumn} from 'react-bootstrap-table';
import InternationalizationStore from '../store/internationalization-store.js';
import { FormattedMessage } from 'react-intl';
import DataInput from '../components/inputs/date.input.js'
import Select from  'react-select';
import ClassesService from "../services/classes-service.js";
import ClassesStore from "../store/classes-store.js";
import fuzzysearch from 'fuzzysearch';
import AssignmentServices from '../services/assignment-services.js';
import { Link , hashHistory } from "react-router";

const allOptions = [
    { value: 4 , label:  <FormattedMessage id={ 'ui-117' } defaultMessage={ 'Listening' }/>, noResultsText: <FormattedMessage id={ "ui-2011"} defaultMessage={ "No Results Found Default" }/> },
    { value: 10 , label: <FormattedMessage id={ 'ui-119' } defaultMessage={ 'Reading' }/>, noResultsText: <FormattedMessage id={ "ui-2011"} defaultMessage={ "No Results Found Default" }/> },
    { value: 1 , label: <FormattedMessage id={ 'ui-118' } defaultMessage={ 'Speaking' }/>, noResultsText: <FormattedMessage id={ "ui-2011"} defaultMessage={ "No Results Found Default" }/>},
    { value: 7 , label: <FormattedMessage id={ 'ui-120' } defaultMessage={ 'Writing' }/> , noResultsText: <FormattedMessage id={ "ui-2011"} defaultMessage={ "No Results Found Default" }/> }]

const coreOptions = [
    { value: 4 ,  label: <FormattedMessage id={ 'ui-117' } defaultMessage={ 'Listening' }/>, noResultsText: <FormattedMessage id={ "ui-2011"} defaultMessage={ "No Results Found Default" }/> },
    { value: 10 , label: <FormattedMessage id={ 'ui-119' } defaultMessage={ 'Reading' }/>, noResultsText: <FormattedMessage id={ "ui-2011"} defaultMessage={ "No Results Found Default" }/> },
    { value: 7 ,  label: <FormattedMessage id={ 'ui-120' } defaultMessage={ 'Writing' }/>, noResultsText: <FormattedMessage id={ "ui-2011"} defaultMessage={ "No Results Found Default" }/>  }]


export default class ContentMaker extends React.Component{

    constructor(props) {
        super(props);

        this.state = {
            tabIndex:0,
            limit:10,
            index:0,
            classes:[],
            searchResults:[],
            search:false,
            classStates:{},
            toggleAll:false,
            catalogID:this.props.params.catalogUID,
            games:allOptions,
            summary:ContentStore.getCatalogSummary(this.props.params.catalogUID).summary,
            catalog:ContentStore.getCatalog(this.props.params.catalogUID),
        };

        var d =   new Date();

        var due = new Date(); due.setDate(due.getDate() + 14);
        this.date  = {};
        this.date.set =    d.getUnixTime();
        this.date.due =  due.getUnixTime();

        this.data = {};

        this.handelPageSelect = this.handelPageSelect.bind(this);
    }

    handelPageSelect(index){
        this.setState({index:index - 1});
    }
    
    setProps(){

        var keys = Object.keys(this.state.classStates);
        var classes = [];

        for(var idx = 0 ; idx < keys.length; idx++) {
            if (!this.state.classStates[keys[idx]].selected) continue;
            classes.push({
                uid:keys[idx],
                allStudents: this.state.classStates[keys[idx]].students.length == 0 ,
                students:this.state.classStates[keys[idx]].students
            });
        }


        this.data.assignedClasses = classes;
    };

    processClasses(classes , propsClasses , propsStudents){

        var isClassSelected = function(uid){
            for(var idx = 0 ; idx < propsClasses.length; idx++) if(propsClasses[idx].uid == uid) return true;
            return false
        };

        var getSelectedStudents = function(classStudents){

            var selected = [];

            for(var idx = 0 ; idx < propsStudents.length; idx++)
            {
                for(var jdx = 0 ; jdx < classStudents.length; jdx++)
                {
                    if(propsStudents[idx].uid == classStudents[jdx].uid) selected.push({ value: propsStudents[idx].uid, label: propsStudents[idx].name })
                }
            }

            return selected;
        };

        var classes = ClassesStore.classes;
        var classStates = {};

        for(var idx = 0 ; idx < classes.length; idx++)
        {
            var selected = isClassSelected(classes[idx].getID());
            var students = selected ? [] : getSelectedStudents(classes[idx].students);
            classStates[classes[idx].getID()] = {allStudents:true , selected:selected ? true : students.length > 0 ? true : false , students:students};
        }

        console.log(classes);
        this.data.assignedClasses = classes;
        return {classes:classes , classStates:classStates}
    }

    renderStudentsSelect(classID , students){
        const options = (students || []).map(function(student){

            return  { value: student.uid, label: student.name}
        });

        return <Select placeholder={<FormattedMessage id={ 'ui-897' } defaultMessage={ 'All Students' }/>} value={this.state.classStates[classID].students}
                       multi={true} onChange={this.handelSelectStudents.bind(this , classID)}  options={options}
                       noResultsText={<FormattedMessage id={ "ui-2011"} defaultMessage={ "No Results Found" }/>} />

    }

    handelSelectStudents(classID , value ){

        var states = this.state.classStates;
        states[classID].students = value;
        states[classID].selected = value.length > 0 ;
        this.setState({classStates:states});
        this.setProps();
    }

    componentDidMount() {
        ClassesService.getViewableClasses();
        //ContentService.fetchCatalog(this.props.params.catalogUID , this.CatalogParams.learning , this.CatalogParams.support)
        ContentService.fetchCatalogSummary(this.props.params.catalogUID)

    }

    componentWillMount(){
        ClassesStore.on("CHANGE" , () => {
            this.setState(this.processClasses(ClassesStore.classes ,  [] ,  []));
            this.setProps();
        });

        ContentStore.on('ON_SUMMARY_FETCH'  , () => {

            this.setState({
                summary:ContentStore.getCatalogSummary(this.props.params.catalogUID).summary
            });

            ContentService.fetchCatalog(this.props.params.catalogUID , ContentStore.getCatalogSummary(this.props.params.catalogUID).summary.learning_ietf , ContentStore.getCatalogSummary(this.props.params.catalogUID).summary.support_ietf );

        });

        ContentStore.on('ON_VOCAB_FETCH'  , () => {

            this.setState({
                catalog:ContentStore.getCatalog(this.props.params.catalogUID),
                loaded:true
            })

        });
    }

    handelSelectLanguage(language){

        if(!language.hasSpeaking)
        {
            this.props.games = coreOptions;
            this.setState({games:coreOptions ,  options : coreOptions});
        }
        else
        {
            this.props.data.games = allOptions;
            this.setState({games:allOptions ,  options : allOptions});
        }

        this.props.data.selectedLanguage = language;
        this.setState({selectedLanguage : language});
    }

    handelSetDataSelect(val){
        this.date.set = (new Date(val)).getUnixTime();
        this.setState({update:!this.state.update});
    }

    handelDueDataSelect(val){
        this.date.due = (new Date(val)).getUnixTime();
        this.setState({update:!this.state.update});
    }

    renderGamesSelect(){

        return <Select onChange={this.handelGamesChange.bind(this)} value={this.state.games} multi={true}  options={this.state.options}
                       noResultsText={<FormattedMessage id={ "ui-2011"} defaultMessage={ "No Results Found" }/>}
                       placeholder={<FormattedMessage id={ 'ui-892' } defaultMessage={ 'Select' }/>}/>;
    }


    handelGamesChange(value){

        if(value.length > 0)
        {
            this.setState({games:value});
        }
    }

    renderList(){


        return this.getPage(this.state.classes).map(function(_class){

            return <tr>
                <td>
                    {_class.getName()}
                </td>
                <td>
                    {this.renderStudentsSelect(_class.getID() , _class.students)}
                </td>
                <td width={20}>
                    <Checkbox onChange={this.handelSelect.bind(this , _class.getID())} inline checked={this.state.classStates[_class.getID()].selected}/>
                </td>
            </tr>

        }.bind(this));

    }

    handelSelect(classID){

        var states = this.state.classStates;
        states[classID].selected = !states[classID].selected;
        this.setState({classStates:states});
        this.setProps();
    }

    renderClasses(){



        return <div className="p-15">
            <Row>
                <Table striped responsive bordered>
                    <thead>
                    <tr>
                        <th><FormattedMessage id={ 'ui-452' } defaultMessage={ 'Class Name' }/></th>
                        <th colSpan={2}><FormattedMessage id={ 'ui-498' } defaultMessage={ 'Assign to' }/></th>
                    </tr>
                    </thead>
                    <tbody>
                    {this.renderList()}
                    </tbody>
                </Table>
            </Row>
            <Row>
                <Pagination
                    prev
                    next
                    first
                    last
                    items={this.state.search ? Math.ceil(this.state.searchResults.length/this.state.limit) : Math.ceil(this.state.classes.length/this.state.limit)}
                    maxButtons={5}
                    activePage={this.state.index+1}
                    onSelect={this.handelPageSelect} />
            </Row>
        </div>
    }

    getPage(objects){

        var rowLimit  = parseInt(this.state.limit);
        return objects.slice(this.state.index*rowLimit, (this.state.index*rowLimit) + rowLimit);
    }


    handleSubmit(){

        this.setState({loaded:false});
        AssignmentServices.createHomework(this.state.summary.title , this.data.assignedClasses , this.date.set , this.date.due , {ietf:ContentStore.getCatalogSummary(this.props.params.catalogUID).summary.learning_ietf} , this.state.catalog.vocab ,  this.state.games , ContentStore.getCatalogSummary(this.props.params.catalogUID).summary.module_uid).then(function(){
            hashHistory.push('/assignment/managment')
        });
    }

    renderLoading(){
        return <CardBody><Row><Col sm={5} smOffset={5} >
            <div className="preloader pl-xl pls-blue">
                <svg className="pl-circular" viewBox="25 25 50 50">
                    <circle className="plc-path" cx="50" cy="50" r="20"/>
                </svg>
            </div>
        </Col></Row></CardBody>
    }

    renderBody(){
        return  <CardBody>
            <Row>
                <Col sm={6}><DataInput onSelect={this.handelSetDataSelect} value={this.date.set} labelTranslationUID="ui-483" labelName="Set"/></Col>
                <Col sm={6}><DataInput onSelect={this.handelDueDataSelect} value={this.date.due} labelTranslationUID="ui-484" labelName="Due"/></Col>
            </Row>
            <Row>
                <Col md={12}>
                    <FormGroup className="fg-line">
                        <ControlLabel  className="fg-label pull-left">
                            <FormattedMessage id={ 'ui-2009' } defaultMessage={ 'Choose Test Type' }/>
                        </ControlLabel>
                        {this.renderGamesSelect()}
                    </FormGroup>
                </Col>
            </Row>
            <Row>
                <Col md={12}>
                    <h6><FormattedMessage id={ 'ui-501' } defaultMessage={ 'Assign' }/></h6>
                    {this.renderClasses()}
                </Col>
            </Row>
            <Row>
                <Col md={12}>
                    <Button disabled={this.data.assignedClasses == undefined || this.data.assignedClasses.length == 0} onClick={this.handleSubmit.bind(this)} className="pull-right" bsStyle="primary">Next</Button>

                </Col>

            </Row>
        </CardBody>
    }

    render()
    {

        let body = this.renderLoading();

        if(this.state.loaded) body = this.renderBody();


        return <Layout>

            <Card>
                <CardHeader>
                    <h4>
                        <FormattedMessage id={ 'ui-886' } defaultMessage={ '' }/> - {this.state.summary.title}
                    </h4>
                </CardHeader>

                {body}
            </Card>

        </Layout>
    }

}


// WEBPACK FOOTER //
// ./src/screens/content-assign.js